import { Link } from "react-router-dom";
import { mediaList, type ContentType } from "@/mocks/media";
import { formatDate } from "@/hooks/useMediaQuery";

const sections: { type: ContentType; label: string; hint: string }[] = [
  { type: "movie", label: "最新电影", hint: "院线新片与修复重映" },
  { type: "tv", label: "最新电视剧", hint: "正在更新的热门剧集" },
  { type: "variety", label: "最新综艺", hint: "每周固定更新的节目" },
];

export default function LatestUpdates() {
  return (
    <section className="w-full px-4 py-12 md:px-6 md:py-14">
      <div className="grid grid-cols-1 gap-8 lg:grid-cols-3 lg:gap-7">
        {sections.map((section) => {
          const items = mediaList
            .filter((item) => item.type === section.type)
            .sort((a, b) => (a.updatedAt < b.updatedAt ? 1 : -1))
            .slice(0, 4);
          return (
            <div key={section.type}>
              <div className="mb-4 flex items-end justify-between border-b border-background-200 pb-3">
                <div>
                  <h2 className="font-heading text-base font-bold text-foreground-950 md:text-lg">
                    {section.label}
                  </h2>
                  <p className="mt-1 font-label text-[11px] text-foreground-500">{section.hint}</p>
                </div>
                <Link
                  to={`/category/${section.type}`}
                  className="group flex items-center gap-1 whitespace-nowrap text-[12px] text-foreground-600 transition-colors hover:text-accent-600"
                >
                  全部
                  <i className="ri-arrow-right-s-line flex h-4 w-4 items-center justify-center group-hover:translate-x-0.5" />
                </Link>
              </div>
              <ul className="flex flex-col gap-3">
                {items.map((item) => (
                  <li key={item.id}>
                    <Link to={`/detail/${item.id}`} className="group flex gap-3">
                      <div className="h-[76px] w-[58px] shrink-0 overflow-hidden rounded-md bg-background-200">
                        <img
                          src={item.cover}
                          alt={`${item.title} 封面`}
                          title={`${item.title} ${item.year}`}
                          className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                        />
                      </div>
                      <div className="min-w-0 flex-1 border-b border-background-200/70 pb-3">
                        <p className="line-clamp-1-custom text-[13px] font-medium text-foreground-900 transition-colors group-hover:text-accent-600">
                          {item.title}
                        </p>
                        <p className="mt-1 line-clamp-1-custom text-[11px] text-foreground-500">
                          {item.genres.join(" / ")} · {item.region}
                        </p>
                        <div className="mt-1.5 flex items-center gap-2">
                          <span className="rounded-sm bg-accent-50 px-1.5 py-0.5 font-label text-[10px] text-accent-700">
                            {item.status}
                          </span>
                          <span className="font-label text-[10px] text-foreground-400">
                            {formatDate(item.updatedAt)} 更新
                          </span>
                        </div>
                      </div>
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          );
        })}
      </div>
    </section>
  );
}